import {
  IconButton,
  InputAdornment,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { font } from "../../../../styles/font";
import { TextFieldMA } from "../../../../styles/styledComponents";
import { theme } from "../../../../styles/theme";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import validator from "validator";
import { VerifyOtp } from "../../verifyOtp";
import { ApplicationContext } from "../../../../context/application_ctx";
import { HttpStatusCode } from "axios";
import { GlobalSnackBar } from "../../../../components/snackBar";
import { ButtonCustom } from "../../../../components/button";
import { IconBack } from "../../../../svgIcons/icons";
import { CompanyProfile } from "../../../../components/companyRegistration/companyProfile";
import { SideBanner } from "../../../../components/maSideBanner";
import { Subscriptions } from "../../../../components/companyRegistration/subscriptions";
import {
  adminSignIn,
  organizationList,
} from "../../../../api/controllers/adminController";

export const AdminSignin = () => {
  const { login } = useContext(ApplicationContext);
  console.log(login);
  const navigate = useNavigate();
  const loginQuery = useMediaQuery("(max-width:800px)");
  const [signInSnack, setSignInSnack] = useState(false);
  const [loaderState, setLoaderState] = useState(false);
  const [error, setError] = useState("");
  const [visibility, setVisiblity] = useState(false);
  const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);
  const [loginNavigation, setLoginNavigation] = useState(0);

  useEffect(() => {
    (async () => {
      try {
        let response = await organizationList();
        console.log(response, "respp");
        if (response.status === HttpStatusCode.Ok) {
          navigate("/admin-dashboard?company");
        }
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  const handleSignin = async () => {
    if (!email) {
      setEmail("");
    }
    if (!password) {
      setPassword("");
    }
    if (email && validator.isEmail(email) && password) {
      console.log("api call");
      setLoaderState(true);
      try {
        let response = await adminSignIn({
          email,
          password,
          paymentStatus: true,
        });
        console.log(response, "responseLogin");
        if (response.status === HttpStatusCode.Ok) {
          setLoaderState(false);

          localStorage.setItem("api-token", response.data.token);
          navigate("/admin-dashboard?company");
        }
        if (response.status === HttpStatusCode.BadRequest) {
          setLoaderState(false);

          setError(response.data.message);
          setSignInSnack(true);
          setTimeout(() => {
            setLoginNavigation(1);
          }, 3000);
        }
        if (response.status === HttpStatusCode.Unauthorized) {
          setLoaderState(false);

          setError(response.data.message);
          setSignInSnack(true);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleSubmit = (e) => {
    if (e.key === "Enter") {
      handleSignin();
    }
  };
  return (
    <>
      <Box
        display={"flex"}
        width="100vw"
        height={"100vh"}
        backgroundColor={theme.col_1}
        alignItems="center"
      >
        <SideBanner query={loginQuery} />
        <Box
          display={"flex"}
          width={loginQuery ? "100%" : "65%"}
          alignItems="center"
          justifyContent="center"
          height={"100%"}
          backgroundColor={"white"}
          flexDirection="column"
        >
          {loginNavigation !== 0 ? (
            <Box width="100%">
              <IconButton
                onClick={() => setLoginNavigation(loginNavigation - 1)}
              >
                <IconBack />
              </IconButton>
            </Box>
          ) : (
            <></>
          )}
          {loginNavigation === 0 || loginNavigation === 1 ? (
            <Box
              display={"flex"}
              gap="26px"
              flexDirection="column"
              justifyContent={"center"}
              alignItems="center"
              width={loginQuery ? "90%" : "53%"}
              height="100%"
            >
              <Box
                display={"flex"}
                flexDirection="column"
                justifyContent="center"
                alignItems={"center"}
                height="100px"
                width="100%"
                gap="7px"
              >
                <Box
                  display={"flex"}
                  width="76px"
                  justifyContent="center"
                  height="60px"
                >
                  <img
                    width={"100%"}
                    height="100%"
                    src={require("../../../../assets/images/logo.png")}
                    alt="Mindamigo"
                  />
                </Box>
                <Typography
                  fontFamily={font.family.fm_2}
                  color={theme.col_2}
                  textAlign="center"
                  fontSize={font.size.fs_2}
                  fontWeight="bold"
                >
                  {loginNavigation === 0
                    ? " Sign in to Mindamigo"
                    : "Verify OTP"}
                </Typography>
              </Box>
              {loginNavigation === 0 ? (
                <>
                  <Box
                    display="flex"
                    width="100%"
                    flexDirection="column"
                    gap="12px"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Box
                      display="flex"
                      width="100%"
                      flexDirection={loginQuery ? "column" : "flex"}
                      gap="16px"
                      justifyContent="center"
                    >
                      <TextFieldMA
                        required
                        error={
                          email === null
                            ? false
                            : !validator.isEmail(email) && email !== ""
                            ? true
                            : email === ""
                            ? true
                            : false
                        }
                        helperText={
                          email === null
                            ? ""
                            : !validator.isEmail(email) && email !== ""
                            ? "Enter valid email"
                            : email === ""
                            ? "Email is required"
                            : ""
                        }
                        onKeyUp={handleSubmit}
                        onChange={(e) => setEmail(e.target.value)}
                        fullWidth
                        label="Email"
                      />
                      <TextFieldMA
                        required
                        error={
                          password === null
                            ? false
                            : // : !validator.isStrongPassword(password) &&
                            //   password !== ""
                            // ? true
                            password === ""
                            ? true
                            : false
                        }
                        helperText={
                          password === null
                            ? ""
                            : // : !validator.isStrongPassword(password) &&
                            //   password !== ""
                            // ? "Password must be strong"
                            password === ""
                            ? "Password is required"
                            : ""
                        }
                        onKeyUp={handleSubmit}
                        onChange={(e) => setPassword(e.target.value)}
                        type={visibility ? "text" : "password"}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() => setVisiblity(!visibility)}
                              >
                                {visibility ? (
                                  <VisibilityOff />
                                ) : (
                                  <Visibility />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        fullWidth
                        label="Password"
                      />
                    </Box>
                    {/* <Box
                      display="flex"
                      width="100%"
                      alignItems="center"
                      justifyContent="flex-end"
                    >
                    
                      <Typography
                        fontFamily={font.family.fm_2}
                        color={theme.col_2}
                        onClick={() => navigate("/admin-change-password")}
                        sx={{cursor:'pointer'}}
                      >
                        Change password
                      </Typography>
                    </Box> */}
                  </Box>
                  <Box
                    display="flex"
                    flexDirection={"column"}
                    width="100%"
                    gap="16px"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <ButtonCustom
                      onClick={handleSignin}
                      fullWidth={true}
                      disabled={loaderState}
                      loaderState={loaderState}
                      borderRadius="42px"
                      size="large"
                      background={theme.col_2}
                      backgroundRipple={theme.col_3}
                      focusColor={theme.col_1}
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      typography={
                        <Typography
                          fontFamily={font.family.fm_2}
                          textTransform={"capitalize"}
                          fontSize={font.size.fs_3}
                          fontWeight="bold"
                          color={theme.col_4}
                        >
                          SIGN IN
                        </Typography>
                      }
                    />
                  </Box>{" "}
                </>
              ) : (
                <>
                  <VerifyOtp
                    loginQuery={loginQuery}
                    email={email}
                    setLoginNavigation={setLoginNavigation}
                  />
                </>
              )}
            </Box>
          ) : (
            <>
              <LoginNav
                loginQuery={loginQuery}
                email={email}
                signInSnack={signInSnack}
                setError={setError}
                setLoginNavigation={setLoginNavigation}
                loginNavigation={loginNavigation}
              />
            </>
          )}
        </Box>
      </Box>
      <GlobalSnackBar open={signInSnack} title={error} close={setSignInSnack} />
    </>
  );
};

const LoginNav = ({
  loginNavigation,
  loginQuery,
  email,
  setLoginNavigation,
  signInSnack,
  setError,
}) => {
  console.log(loginNavigation, "navCompo");
  switch (loginNavigation) {
    case 1:
      return (
        <VerifyOtp
          loginQuery={loginQuery}
          email={email}
          setLoginNavigation={setLoginNavigation}
        />
      );
    case 2:
      return <CompanyProfile signInSnack={signInSnack} setError={setError} />;
    case 3:
      return <Subscriptions signInSnack={signInSnack} setError={setError} />;
    default:
      return;
  }
};
